import React from 'react';
import SelectLanguage from '../../OnboardingNew/GccComponents/SelectLanguage/SelectLanguage';

import * as S from './PageHeader.styles';

const PageHeader = ({handleChange, currentLang}) => {
  return (
    <S.Container>
      <h2>{currentLang === 'arabic' ? 'اتصل بنا' : 'Contact Us'}</h2>
      <SelectLanguage handleOptionChange={handleChange} currentLang={currentLang} />
    </S.Container>
  );
};

export default PageHeader;
